// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"churchevent_mainContent__1cFAh","buttons":"churchevent_buttons__2wf7f","table":"churchevent_table__3I8fG"};